export class LimitePlataformaContaRecord {
    possuiLimite: boolean;
    limiteExcedido: boolean;
    limite: number | null;
    quantidade: number;

    public get porcentagem(): number {
        if (!this.possuiLimite || !this.limite || this.limite === 0)
            return 0;

        return (this.quantidade / this.limite) * 100;
    }

    static fromRaw(raw: any): LimitePlataformaContaRecord {
        return Object.assign(new LimitePlataformaContaRecord(), raw);
    }
}

export class LimitePlataformaConta {

    possuiLimite: boolean;
    carteira: LimitePlataformaContaRecord;
    templateImportacao: LimitePlataformaContaRecord;
    lista: LimitePlataformaContaRecord;
    estrategia: LimitePlataformaContaRecord;

    constructor() {

    }

    static fromRaw(raw: any): LimitePlataformaConta {
        let data = Object.assign(new LimitePlataformaConta(), raw);
        data.carteira = LimitePlataformaContaRecord.fromRaw(raw.carteira);
        data.templateImportacao = LimitePlataformaContaRecord.fromRaw(raw.templateImportacao);
        data.lista = LimitePlataformaContaRecord.fromRaw(raw.lista);
        data.estrategia = LimitePlataformaContaRecord.fromRaw(raw.estrategia);
        return data;
    }
}


export enum AtualizarPainelTipo {
    limitesConta = 1,
    limitesProvedor = 2,
    quantidadeIndexada = 3,
    quantidadeExportada = 4,
    estrategiasExportadas = 5
}